import type { Dayjs } from "dayjs";

/**
 * 根据名字生成一致的头像颜色
 * 同一个名字总是返回相同的颜色
 * 使用简单哈希算法减少颜色碰撞
 */
export function getAvatarColor(name: string): string {
  if (!name) return "#8c8c8c"; // 默认灰色

  const colors = [
    "#667eea", // 紫蓝色
    "#f093fb", // 粉紫色
    "#4facfe", // 天蓝色
    "#43e97b", // 翠绿色
    "#fa709a", // 玫红色
    "#30cfd0", // 青色
    "#ff9a9e", // 粉红色
    "#a8edea", // 薄荷色
  ];

  // 使用整个名字计算哈希值，减少碰撞
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // 转换为32位整数
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

/**
 * 获取姓名首字母（支持中文和英文）
 */
export function getNameInitial(name?: string): string {
  if (!name) return "?";
  return name.charAt(0).toUpperCase();
}

/**
 * 将可能的字符串/空值转换为数字，非法时返回 undefined
 */
export function normalizeNumber(value?: unknown): number | undefined {
  if (value === undefined || value === null || value === "") return undefined;
  const num = Number(value);
  return Number.isNaN(num) ? undefined : num;
}
/** 将 Dayjs 范围拆为 [start, end] 字符串（YYYY-MM-DD），空则 undefined */
export function extractRange(
  range?: [Dayjs, Dayjs]
): readonly [string | undefined, string | undefined] {
  if (!range || range.length !== 2) return [undefined, undefined] as const;
  const [start, end] = range;
  return [
    start ? start.format("YYYY-MM-DD") : undefined,
    end ? end.format("YYYY-MM-DD") : undefined,
  ] as const;
}
/**
 * 递归遍历对象，将空字符串 "" 转换为 null
 */
export function convertEmptyStringToNull(obj: any): any {
  if (obj === null || obj === undefined) return obj;

  if (typeof obj === "string") {
    return obj.trim() === "" ? null : obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(convertEmptyStringToNull);
  }

  if (typeof obj === "object") {
    const newObj: any = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = convertEmptyStringToNull(obj[key]);
      }
    }
    return newObj;
  }

  return obj;
}
